// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"267":"795b5412","358":"1c1d4d27","914":"38e18d89"}[chunkId] + ".chunk.js";
};